// Axios
import Axios from "./axios"

export const verifyEmail = (body) => {
    return new Promise((resolve, reject) => {
        const data = Axios.put(`/user/verifyEmail`, body)
        resolve(data)
    })
}